import React, { useEffect, useState } from "react";
import CustomModal from "../../reusable/CustomModal/CustomModal";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { Tooltip } from "antd";
import { get_all_item_discount } from "../../api/admin/coupons";
import { useDispatch, useSelector } from "react-redux";

const AllItemsDiscountModal = ({ visible, header, setVisible, footer }) => {
  const dispatch = useDispatch();
  const { allItemDiscounts } = useSelector((state) => state.coupon);

  useEffect(() => {
    const obj = { page: 1, pageSize: 500, isEndUser: true };
    dispatch(get_all_item_discount(obj));
  }, []);

  return (
    <>
      <CustomModal
        visible={visible}
        title={header}
        onClose={setVisible}
        width={600}
        className="filter-modal"
        footer={footer}
      >
        <div className="my-5 pb-5">
          <table class="table pb-5 table-hover align-middle table-bordered">
            <thead>
              <tr className="text-center">
                <th scope="col">No. of Items (In Order)</th>
                <th scope="col">Discount Per Item</th>
                <th scope="col">Total Discount</th>
              </tr>
            </thead>
            <tbody>
              {allItemDiscounts?.data?.map((item, index) => (
                <tr className="text-center">
                  <td>{item?.numberofItems}</td>
                  <td>${item?.discountPerItem}</td>
                  <td className="d-flex align-items-center justify-content-center">
                    <span>
                      {item?.numberofItems}*{item?.discountPerItem}=$
                      {(
                        item?.numberofItems *
                        item?.discountPerItem
                      ).toLocaleString()}
                    </span>
                    <Tooltip
                      title={`All the items more than ${
                        item?.numberofItems
                      } will also eligible for same discount. ex:  ${
                        item?.numberofItems + 1
                      }*${item?.discountPerItem}=$
                      ${(
                        (item?.numberofItems + 1) *
                        item?.discountPerItem
                      ).toLocaleString()}`}
                      placement="top"
                    >
                      <span className="ms-2 cursor-pointer">
                        <IoMdInformationCircleOutline size={17} />
                      </span>
                    </Tooltip>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CustomModal>
    </>
  );
};

export default AllItemsDiscountModal;
